import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { compose } from "recompact"
import { Box } from "@infotech/uikit-grid"
import isEmpty from "lodash/isEmpty"
import sortBy from "lodash/sortBy"
import find from "lodash/find"
import { selectCurrentList } from "src/engine/modules/lists/selectors"
import { readList } from "src/engine/modules/lists/actions/creators/read"
import {
  LIST_NAME,
  getBasicUrl,
} from "src/containers/PlanType/Item/Templates/helper/constants"
import getTemplatesList from "src/containers/PlanType/Item/Templates/helper/templatesApi"
import styles from "../styles.css"

const ReadOnlyList = props => {
  const {
    planTypeId,
    readList,
    planTypeTemplates,
    planTypes: { data },
    currentToken,
  } = props

  const [templatesList, getList] = useState([])
  useEffect(() => {
    if (
      currentToken &&
      templatesList &&
      (isEmpty(templatesList) || templatesList.status === `fail`)
    ) {
      getTemplatesList(currentToken, getList)
    }
    if (planTypeId && data && !isEmpty(templatesList)) {
      readList({
        basicUrl: getBasicUrl(planTypeId),
        name: LIST_NAME,
        outerData: templatesList,
      })
    }
  }, [planTypeId, templatesList])
  const templatesData =
    (planTypeTemplates &&
      !planTypeTemplates.reading &&
      !isEmpty(planTypeTemplates.data) &&
      sortBy(
        planTypeTemplates.data
          .map(item =>
            find(planTypeTemplates.outerData, outer => outer.code === item),
          )
          .filter(Boolean),
        item => item.name,
      )) ||
    []
  return (
    <>
      {planTypeTemplates && !isEmpty(planTypeTemplates.data) && (
        <Box loose className={styles.ReadOnlyWrapper} pt="2md">
          {templatesData.map(item => (
            <Box
              loose
              className={styles.ReadOnlyItem}
              flex
              pl="2md"
              pt="1md"
              pb="1md"
            >
              <Box loose>
                <Box pt="4px" loose className={styles.CurrentReadOnlyLabel}>
                  {item.name}
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </>
  )
}

ReadOnlyList.propTypes = {
  planTypeId: PropTypes.oneOf([`string`, `number`]).isRequired,
  readList: PropTypes.func.isRequired,
  planTypeTemplates: PropTypes.shape({
    color: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
  data: PropTypes.shape({
    status: PropTypes.string,
    data: PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
    }),
  }).isRequired,
}

export default compose(
  connect(
    state => ({
      planTypeTemplates: selectCurrentList(state, LIST_NAME),
    }),
    {
      readList,
    },
  ),
)(ReadOnlyList)
